import { CCardHeader, CCardTitle, CCol, CRow } from '@coreui/react-pro'
import React, { useContext } from 'react'
import { LogContext } from 'src/context/LogContext'

const OrderLogsHeader = () => {
  const { t } = useContext(LogContext)

  return (
    <CCardHeader>
      <CRow className="my-2">
        <CCol>
          <CCardTitle className="mt-2">{t('order-logs')}</CCardTitle>
        </CCol>
      </CRow>
    </CCardHeader>
  )
}

export default OrderLogsHeader
